import React from 'react';
import Grid from '../../../../muiComponents/Grid';
import GridChild from '../../../../muiComponents/GridChild';
import { filterColumnGrid } from '../../yourBookings/yourBookingsHelpers';
import LoadedOptionsTypeahead from '../../../../muiComponents/LoadedOptionsTypeahead';
import TextInput from '../../../../muiComponents/TextInput/TextInput';
import { useODataMultipleQueries } from '../../../../customHooks/useODataMultipleQueries';
import { readOnlyEntities } from '../../../../utils/commonVariables/entityKeys';
import { IChannelManagerStatusType } from '../../../../types/entities/IChannelManagerStatusType';
import { IExternalIntegrationType } from '../../../../types/entities/IExternalIntegrationType';
import { useChannelManagers } from '../../../contextsProperty/ContextChannelManagers';
import FiltersBar from '../../../../Table/FiltersBar';
import { IFilterOptionState } from '../../../../types/lists/listTypes';
import {
    gridSpacing10,
    gridSpacing15,
} from '../../../../utils/commonVariables/grid';

const ChannelManagersFiltersBar = () => {
    const {
        handleFilterChange,
        filters,
        handleSearch,
        resetFilters,
        isLoading,
        currentResults,
        totalResults,
    } = useChannelManagers();
    const queries = [
        {
            key: 'statuses',
            endpoint: {
                entityName: readOnlyEntities.ChannelManagerStatusType,
                select: ['Id', 'LocalizedCaption', 'Caption', 'Name', 'Color'],
                filter: [`Enabled eq true`, `Key ne 'LOST'`],
                orderBy: 'LocalizedCaption asc',
            },
            transform: (items: IChannelManagerStatusType[]) => {
                return items.map(item => ({
                    Id: item.Id,
                    label: item.LocalizedCaption || item.Caption || item.Name,
                    color: item.Color,
                }));
            },
        },
        {
            key: 'types',
            endpoint: {
                entityName: readOnlyEntities.ExternalIntegrationType,
                select: ['Id', 'LocalizedCaption', 'Caption', 'Name'],
                filter: [`Enabled eq true`, `IsProduct or IsContent`],
                orderBy: 'LocalizedCaption asc',
            },
            transform: (items: IExternalIntegrationType[]) => {
                return items.map(item => ({
                    Id: item.Id,
                    label: item.LocalizedCaption || item.Caption || item.Name,
                    color: item.Color,
                }));
            },
        },
    ];

    const { statuses, types } = useODataMultipleQueries({
        queries,
        dependencies: [],
    });

    return (
        <FiltersBar
            title='channel_managers'
            clearFilters={resetFilters}
            search={async () => await handleSearch(1)}
            isLoading={isLoading}
            currentResults={currentResults}
            totalResults={totalResults}
        >
            <Grid
                className='flex-grow'
                columnSpacing={gridSpacing10}
                rowSpacing={gridSpacing15}
            >
                <GridChild gridProps={filterColumnGrid}>
                    <LoadedOptionsTypeahead
                        labelText={'status'}
                        options={statuses.data || []}
                        value={filters.IdChannelManagerStatusType.value || null}
                        handleChange={(
                            e: React.SyntheticEvent<Element, Event>,
                            newValue: IFilterOptionState | null
                        ) =>
                            handleFilterChange(
                                'IdChannelManagerStatusType',
                                newValue
                            )
                        }
                    />
                </GridChild>
                <GridChild gridProps={filterColumnGrid}>
                    <TextInput
                        labelText={'name'}
                        id={'bookingCode'}
                        value={filters.Name.value || ''}
                        handleChange={(
                            e: React.SyntheticEvent<Element, Event>,
                            newValue: string
                        ) => handleFilterChange('Name', newValue)}
                        onKeyPress={async (e: React.KeyboardEvent) => {
                            if (e.key === 'Enter') {
                                await handleSearch(1);
                            }
                        }}
                    />
                </GridChild>
                <GridChild gridProps={filterColumnGrid}>
                    <LoadedOptionsTypeahead
                        labelText={'type'}
                        options={types.data || []}
                        value={filters.IdExternalIntegrationType.value || null}
                        handleChange={(
                            e: React.SyntheticEvent<Element, Event>,
                            newValue: IFilterOptionState | null
                        ) =>
                            handleFilterChange(
                                'IdExternalIntegrationType',
                                newValue
                            )
                        }
                    />
                </GridChild>
            </Grid>
        </FiltersBar>
    );
};

export default ChannelManagersFiltersBar;
